document.addEventListener('DOMContentLoaded', function() {
    var subMenus = document.querySelectorAll('.header__navigation-mobile ul.sub-menu');
    
    subMenus.forEach(function(subMenu) {
        var backButton = document.createElement('li');
        backButton.classList.add('menu-back');
        
        var backLink = document.createElement('a');
        backLink.href = '#';
        
        var backIcon = document.createElement('i');
        backIcon.classList.add('prop-icon-12');
        
        var backText = document.createTextNode('Wróć');
        
        backLink.appendChild(backIcon);
        backLink.appendChild(backText);
        
        backButton.appendChild(backLink);
        subMenu.appendChild(backButton);
        
        backButton.addEventListener('click', function(event) {
            event.preventDefault();
            
            var parentUl = subMenu.closest('ul');
            if (parentUl) {
                parentUl.classList.remove('active');
            }
        });
    });

    var menuItems = document.querySelectorAll('.header__navigation-mobile .menu-item-has-children > a');
    
    menuItems.forEach(function(item) {
        item.addEventListener('click', function(event) {
            event.preventDefault();
            
            var submenu = this.nextElementSibling;
            
            if (submenu) {
                submenu.classList.toggle('active');
            }
        });
    });

    var closeMenu = document.querySelector('.header__close-menu');
    var headerContentMobile = document.querySelector('.header__content-mobile');
    var navigationMobile = document.querySelector('.header__navigation-mobile');
    var ulElements = navigationMobile.querySelectorAll('ul');
    
    closeMenu.addEventListener('click', function(event) {
        event.preventDefault();
        
        headerContentMobile.classList.remove('active');
        
        ulElements.forEach(function(ul) {
            ul.classList.remove('active');
        });
    });


    
    var closeMenu = document.querySelector('.header__menu-trigger');
    var headerContentMobile = document.querySelector('.header__content-mobile');
    
    closeMenu.addEventListener('click', function(event) {
        event.preventDefault();
        
        headerContentMobile.classList.add('active');
    });

    
});